import React, { useState } from 'react'
import NavbarTop from '../Components/NavbarTop'
import { ReactComponent as EyeIcon } from '../../assets/login/eye.svg';
import { ReactComponent as Silhouette } from '../../assets/login/Silhouette.svg';
import { ReactComponent as SignupGuy } from '../../assets/illustration/SignupGuy.svg'
import { Link } from 'react-router-dom';
import logo from '../../assets/logo/radis.png'
import ErrorText from '../../commonComponents/ErrorText.js'

// NAVIGATE
import { useNavigate } from "react-router-dom";

// REDUX
import { useDispatch } from 'react-redux';
import { sendSignInLinkEmail } from "../../redux/actions/authActions";

// TEMP
// import { sendSignInLinkToEmail } from "firebase/auth";


const SignupPage = () => {
  return (
    <>
      <NavbarTop/>
      
      <div className='flex justify-center w-full h-full font-Poppins-Regular'>
          <div className='bg-white h-[580px] w-[960px] absolute top-[155px] shadow-lg rounded-2xl'>
              <div className='h-full w-[400px] relative left-[15px] flex justify-center'>
                  <div className='relative top-20 h-[490px]'>
                      <h1 className='font-bold relative top-[20px] text-2xl font-Poppins-SemiBold'>
                          Connectez-vous
                      </h1>
                      <div className='relative flex align-middle top-[30px]'>
                          <p className='text-xs'>
                              Pas encore de compte ?
                              <button className='text-[#169A6A] text-xs relative left-1'>
                                  Inscrivez-vous
                              </button>
                          </p>
                      </div>
                      <div className='relative top-14'>
                          <h1 className='font-Poppins-SemiBold'>
                              Adresse email
                          </h1>
                          <input
                          className='rounded-xl border-[1px] border-[#BEC4C] w-[290px] font-Poppins-Regular p-[10px]'
                              type="email"
                              placeholder='email@company.com'
                              autoComplete='email'
                          >
                          </input>
                          <Silhouette className='relative bottom-[35px] left-[260px]'/>
                      </div>
                      <div className='font-Poppins-SemiBold relative top-[50px]'>
                          <h1 className=''>
                              Mot de passe
                          </h1>
                          <input
                          className='rounded-xl border-[1px] border-[#BEC4C] w-[290px] font-Poppins-Regular p-[10px] relative'
                              type="password"
                              placeholder='motdepasse'
                              autoComplete='password'
                          >
                          </input>
                          <EyeIcon  className=' relative bottom-[48px] left-[255px]'/>
                          <Link to='/SigninConfirmationPage'>
                              <button className='bg-[#169A6A] text-white w-[290px] h-[50px] rounded-lg relative top-[40px]'>
                                  Se connecter
                              </button>
                          </Link>
                      </div>
                          <p className='text-[#BEC4C] text-xs font-Poppins-Light relative mt-[7px]'>
                              <input className='mr-2 bg-[#BEC4C]' type="checkbox"/>
                              Rester connecté
                          </p>
                      <p className='text-[#BEC4C] absolute bottom-0 text-center text-xs w-full font-Poppins-Light'>
                          fait pour la planète par lokalité © - 2022
                      </p>
                  </div>
              </div>
              <div className='bg-[#F3F5F7] absolute right-0 top-0 rounded-2xl h-full w-[530px] flex justify-center'>
                  <div className='relative top-20 font-PoetsenOne'>
                      <SignupGuy/>
                      <h1 className='relative text-4xl w-[180px] text-center left-20 top-[25px]'>
                          Bienvenue
                      </h1>
                      <div className='relative text-4xl w-[180px] text-center left-[70px] top-[35px] flex align-middle'>
                          <h1>
                              chez
                          </h1>
                          <h1 className='text-[#169A6A] relative left-3'>
                              Lokalité
                          </h1>
                      </div>
                      <p className='relative text-center w-[220px] left-[70px] top-[50px] text-xs font-Poppins-Light'>
                          Évaluer, réduire et communiquer son impact environemental en toute simplicité
                      </p>
                  </div>
              </div>
          </div>
          <img src={logo} alt='logo' className='absolute h-[320px] transparent left-[965px] top-[120px] opacity-30'/>
      </div>
    </>
  )
}

export default SignupPage